/**
 * @file        src/lib/placeholder.js
 * @description Neutral "no photo" placeholder used when a property/room has no
 *              supplier images. This is deliberately a generic graphic (not a
 *              stock hotel photo) so we never misrepresent a property with
 *              imagery that isn't its own.
 * @author      Kinetika Labs
 * @created     2026-06-24
 */

// Inline SVG (data-URI) — a dark panel with a small photo glyph. Self-contained
// so it needs no network request and can be used directly as an <img src>.
export const NO_IMAGE =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
      <rect width="400" height="300" fill="#0e1726"/>
      <g fill="none" stroke="#2a3a4f" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">
        <rect x="140" y="110" width="120" height="90" rx="10"/>
        <circle cx="172" cy="140" r="10"/>
        <path d="M150 196 184 162 206 184 232 150 250 196"/>
      </g>
      <text x="200" y="232" fill="#41546e" font-family="sans-serif" font-size="16" text-anchor="middle">No photo available</text>
    </svg>`,
  );
